/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentErrorResponseCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const IncidentErrorResponse = zod.object({
  code: zod.enum([
    'INVALID_REQUEST',
    'SESSION_REQUIRED',
    'CAPABILITY_DENIED',
    'NOT_FOUND',
    'VERSION_CONFLICT',
    'INCIDENT_RESOLVED',
    'CUSTOMER_ARCHIVED',
    'INCIDENT_TEAM_FIXED',
    'TEAM_INACTIVE',
    'IDEMPOTENCY_CONFLICT',
    'PAYLOAD_TOO_LARGE',
    'RATE_LIMITED',
    'STORAGE_UNAVAILABLE',
    'DEPENDENCY_UNAVAILABLE',
    'INTERNAL_ERROR',
  ]),
  message: zod.enum([
    'Incident request is invalid.',
    'Sign in to continue.',
    'Incident access is not permitted.',
    'Incident was not found.',
    'Incident has changed; reload before retrying.',
    'Resolution is final.',
    'Archived customers cannot be selected.',
    'Team can only be changed while the incident is open.',
    'Select one active team.',
    'Idempotency key was already used for another request.',
    'Alert exceeds the supported size.',
    'Too many requests; retry later.',
    'Incident storage is unavailable.',
    'Incident dependency is unavailable.',
    'Incident response is unavailable.',
  ]),
  correlationId: zod.uuid().regex(incidentErrorResponseCorrelationIdRegExp),
  fieldErrors: zod
    .record(
      zod.string(),
      zod.enum(['Invalid value.', 'Required value.', 'Limit exceeded.', 'Select one active team.']),
    )
    .optional(),
});

export type IncidentErrorResponse = zod.input<typeof IncidentErrorResponse>;
export type IncidentErrorResponseOutput = zod.output<typeof IncidentErrorResponse>;
